export default __webpack_public_path__ + "static/media/B.39b24312.svg";